import createBrowserHistory from 'history/lib/createBrowserHistory';

const history = createBrowserHistory();

export default history;
